import axios from "axios";
import {SERVER_IP, SERVER_IP_VIDEO} from "./constants";

export const deleteDocument = async (userID, fileID, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/pdf/delete', {
            "user_id" : userID,
            "file_id" : fileID,
        });
        console.log("response from /pdf/delete", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.data.status === 400) {
            return {
                "status" : 400,
            }
        }
    } catch (error) {
        console.log("/pdf/delete error", error);
        return null;
    }
}

export const deleteVideo = async (userID, fileID, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/videos/delete', {
            "user_id" : userID,
            "file_id" : fileID,
        });
        console.log("response from /videos/delete", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.data.status === 400) {
            return {
                "status" : 400,
            }
        }
    } catch (error) {
        console.log("/videos/delete error", error);
        return null;
    }
}

export const deleteGeneration = async (userID, generationID, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/pdf/delete_generation', {
            "user_id" : userID,
            "generation_id" : generationID,
        });
        console.log("response from /pdf/delete_generation", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.data.status === 401) {
            return {
                "status" : 401,
            }
        }
    } catch (error) {
        console.log("/pdf/delete_generation error", error);
        return null;
    }
}


export const renameDocument = async (newName, userID, fileID, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/pdf/rename', {
            "new_name" : newName.toString(),
            "user_id" : userID.toString(),
            "file_id" : fileID.toString(),
        });
        console.log("response from /pdf/rename", response)
        if (response.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.status === 400) {
            return {
                "status" : 400,
            }
        }
    } catch (error) {
        console.log("/pdf/rename error", error);
        return null;
    }
}

export const renameAudiobook = async (newName, userID, fileID, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/pdf/rename', {
            "new_name" : newName.toString(),
            "user_id" : userID.toString(),
            "file_id" : fileID.toString(),
        });
        console.log("response from /pdf/rename", response)
        if (response.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.status === 400) {
            return {
                "status" : 400,
            }
        }
    } catch (error) {
        console.log("/pdf/rename error", error);
        return null;
    }
}

export const renameVideo = async (newName, userID, fileID, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/videos/rename', {
            "new_name" : newName.toString(),
            "user_id" : userID.toString(),
            "file_id" : fileID.toString(),
        });
        console.log("response from /videos/rename", response)
        if (response.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.status === 400) {
            return {
                "status" : 400,
            }
        }
    } catch (error) {
        console.log("/videos/rename error", error);
        return null;
    }
}

export const renameGeneration = async (newName, userID, generationID, serverIP) => {
    // console.log("renameGeneration newName payload", newName)
    // console.log("renameGeneration userID payload", userID)
    // console.log("renameGeneration generationID payload", generationID)
    try {
        const response = await axios.post(serverIP + '/pdf/rename_generation', {
            "new_generation_title" : newName.toString(),
            "user_id" : userID.toString(),
            "generation_id" : generationID.toString(),
        });
        console.log("response from /pdf/rename_generation", response)
        if (response.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.status === 401) {
            return {
                "status" : 401,
            }
        }
    } catch (error) {
        console.log("/pdf/rename_generation error", error);
        return null;
    }
}

export const deleteAccount = async (userID, serverIP) => {
    try {
        const response = await axios.post(serverIP + '/delete_user', {
            "user_id" : userID.toString(),
        });
        console.log("response from /delete_user", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        } else if (response.data.status === 401) {
            return {
                "status" : 401,
            }
        }
    } catch (error) {
        console.log("/delete_user error", error);
        return null;
    }
}
